exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vs__dropdown-menu[data-v-5290283e] {\n  z-index: 10030 !important;\n}\n.con-vs-popup[data-v-5290283e] .vs-popup {\n  width: 700px !important;\n  height: auto !important;\n}\n.con-vs-popup[data-v-5290283e] .vs-popup--content {\n  width: 700px !important;\n  height: auto !important;\n}\r\n", ""]);

// exports
